function toInches(ft, inch) {
  return (parseInt(ft, 10) || 0) * 12 + (parseInt(inch, 10) || 0);
}

function fromInches(total) {
  return {
    ft: Math.floor(total / 12),
    inch: total % 12
  };
}

function extractSliderRange(block) {
  const handles = block.querySelectorAll('.noUi-handle');
  if (handles.length !== 2) {
    // Try alternative method if handles not found
    const rangeInputs = block.querySelectorAll('input[type="range"], input[type="number"]');
    if (rangeInputs.length >= 2) {
      const min = parseInt(rangeInputs[0].min || rangeInputs[0].value, 10);
      const max = parseInt(rangeInputs[1].max || rangeInputs[1].value, 10);
      if (!isNaN(min) && !isNaN(max)) {
        return { min, max };
      }
    }
    return null;
  }
  const min = parseInt(handles[0].getAttribute('aria-valuemin'), 10);
  const max = parseInt(handles[1].getAttribute('aria-valuemax'), 10);
  return { min, max };
}

// URL parameter utilities
function getURLParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function setURLParameter(name, value) {
  const url = new URL(window.location);
  url.searchParams.set(name, value);
  window.history.replaceState({}, '', url);
}

function parseRangeFromURL(paramValue) {
  if (!paramValue) return null;
  const decoded = decodeURIComponent(paramValue);
  const parts = decoded.split(':');
  if (parts.length !== 2) return null;
  
  const min = parseInt(parts[0], 10);
  const max = parseInt(parts[1], 10);
  
  if (isNaN(min) || isNaN(max)) return null;
  return { min, max };
}

function formatRangeForURL(min, max) {
  return `${min}:${max}`;
}

// Global state management
const sliderState = {
  instances: new Map(),
  updateFlags: new Map(),
  healthChecks: new Map(),
  mobileContainerObserver: null
};

// Setup event delegation for mobile container
function setupMobileEventDelegation() {
  const mobileContainer = document.querySelector('div.boost-sd__filter-product-list.boost-sd__fpl-app-block');
  if (!mobileContainer) {
    //console.log(`[DELEGATION] Mobile container not found, will retry`);
    setTimeout(setupMobileEventDelegation, 500);
    return;
  }
  
  //console.log(`[DELEGATION] Setting up event delegation for mobile container`);
  
  // Remove any existing delegation listener
  if (mobileContainer._delegationHandler) {
    mobileContainer.removeEventListener('pointerdown', mobileContainer._delegationHandler);
  }
  
  // Add delegated event handler for all interactions within the mobile container
  const delegationHandler = (e) => {
    // Check if the target is within one of our sliders
    const sliderElement = e.target.closest('[data-slider-id]');
    if (!sliderElement) return;
    
    const sliderId = sliderElement.getAttribute('data-slider-id');
    const sliderData = sliderState.instances.get(sliderId);
    
    if (sliderData && sliderData.element && !sliderData.element.noUiSlider) {
      //console.log(`[DELEGATION] Detected interaction with destroyed slider ${sliderId}, re-initializing`);
      
      // Find the inches block and re-inject
      const urlParam = sliderElement.querySelector('[data-url-param]')?.getAttribute('data-url-param');
      if (urlParam) {
        setTimeout(() => {
          runInjection();
        }, 50);
      }
    }
  };
  
  mobileContainer._delegationHandler = delegationHandler;
  mobileContainer.addEventListener('pointerdown', delegationHandler, { capture: true });
}

// Enhanced slider injection with better mobile support
function injectFeetInchesSlider({ inchesSelector, sliderId, labelText, urlParamName }) {
  //console.log(`[INJECT] Starting injection for ${urlParamName}`);
  
  const desktopContainer = document.querySelector('#boost-sd-filter-tree-column');
  const mobileContainer = document.querySelector('#boost-sd_filter-tree-mobile');
  
  //console.log(`[INJECT] Desktop container found: ${!!desktopContainer}`);
  //console.log(`[INJECT] Mobile container found: ${!!mobileContainer}`);
  
  const containers = [desktopContainer, mobileContainer].filter(Boolean);
  
  containers.forEach(container => {
    const containerType = container.id.includes('mobile') ? 'mobile' : 'desktop';
    //console.log(`[INJECT] Processing ${containerType} container`);
    
    const inchesBlocks = container.querySelectorAll(inchesSelector);
    //console.log(`[INJECT] Found ${inchesBlocks.length} inches blocks in ${containerType}`);
    
    inchesBlocks.forEach((inchesBlock, index) => {
      const uniqueId = `${sliderId}-${containerType}-${index}`;
      
      // First, remove any existing custom slider in this block
      const existingCustomSlider = inchesBlock.querySelector(`[data-slider-id="${uniqueId}"]`);
      if (existingCustomSlider) {
        //console.log(`[INJECT] Removing existing custom slider ${uniqueId}`);
        existingCustomSlider.remove();
      }
      
      // Check if slider already exists in our state
      const existingSliderData = sliderState.instances.get(uniqueId);
      if (existingSliderData && document.body.contains(existingSliderData.element)) {
        // Verify the slider is still functional
        if (existingSliderData.element.noUiSlider) {
          //console.log(`[INJECT] Slider ${uniqueId} exists and is functional`);
          
          // Re-verify event listeners are attached
          ensureEventListeners(uniqueId, inchesBlock, urlParamName);
          return;
        } else {
          //console.log(`[INJECT] Slider ${uniqueId} exists but is not functional, recreating`);
          cleanupSlider(uniqueId);
        }
      }

      const inchesRange = extractSliderRange(inchesBlock);
      if (!inchesRange) {
        //console.log(`[INJECT] Could not extract range for ${uniqueId}, trying default range`);
        // Use a default range if extraction fails
        const defaultRange = { min: 0, max: 300 };
        //console.log(`[INJECT] Using default range ${defaultRange.min}-${defaultRange.max}`);
      }
      
      const range = inchesRange || { min: 0, max: 300 };

      //console.log(`[INJECT] Creating slider ${uniqueId} with range ${range.min}-${range.max}`);

      // Create slider container
      const sliderContainer = document.createElement('div');
      sliderContainer.style.marginTop = '5rem';
      sliderContainer.setAttribute('data-slider-id', uniqueId);
      sliderContainer.setAttribute('data-container-type', containerType);

      const label = document.createElement('label');
      label.innerText = labelText;
      label.style.display = 'none';
      label.style.fontWeight = 'bold';
      label.style.marginBottom = '10px';

      const slider = document.createElement('div');
      slider.id = uniqueId;
      slider.style.marginTop = '0.5rem';
      slider.setAttribute('data-url-param', urlParamName);

      sliderContainer.appendChild(label);
      sliderContainer.appendChild(slider);
      
      const wrapper = inchesBlock.querySelector('.boost-sd__filter-option-itemwrapper');
      if (!wrapper) {
        console.error(`[INJECT] Could not find wrapper for ${uniqueId}`);
        return;
      }
      
      wrapper.appendChild(sliderContainer);

      // Get current values
      const minInput = inchesBlock.querySelector('input[data-type="min"]');
      const maxInput = inchesBlock.querySelector('input[data-type="max"]');
      
      let currentMin, currentMax;
      const urlRange = parseRangeFromURL(getURLParameter(urlParamName));
      
      if (urlRange) {
        currentMin = urlRange.min;
        currentMax = urlRange.max;
      } else {
        currentMin = minInput ? parseInt(minInput.value, 10) || range.min : range.min;
        currentMax = maxInput ? parseInt(maxInput.value, 10) || range.max : range.max;
      }

      // Create the noUiSlider
      try {
        const sliderInstance = noUiSlider.create(slider, {
          start: [currentMin, currentMax],
          connect: true,
          step: 1,
          range: {
            min: range.min,
            max: range.max
          },
          tooltips: [true, true],
          format: {
            to: val => {
              const rounded = Math.round(val);
              const feet = Math.floor(rounded / 12);
              const inches = rounded % 12;
              return `${feet}'${inches}"`;
            },
            from: val => parseInt(val)
          }
        });

        // Store slider data
        sliderState.instances.set(uniqueId, {
          element: slider,
          instance: sliderInstance,
          containerType: containerType,
          urlParamName: urlParamName,
          inchesBlock: inchesBlock
        });

        // Initialize update flag
        sliderState.updateFlags.set(uniqueId, false);

        // Attach all event listeners
        attachSliderEventListeners(uniqueId, inchesBlock, urlParamName);
        
        // Start health monitoring
        startHealthMonitoring(uniqueId);

        //console.log(`[INJECT] Completed setup for slider ${uniqueId}`);
        
      } catch (error) {
        console.error(`[INJECT] Error creating slider ${uniqueId}:`, error);
      }
    });
  });
}

// Attach event listeners with better error handling
function attachSliderEventListeners(uniqueId, inchesBlock, urlParamName) {
  const sliderData = sliderState.instances.get(uniqueId);
  if (!sliderData || !sliderData.instance) {
    console.error(`[EVENTS] No slider instance found for ${uniqueId}`);
    return;
  }

  const slider = sliderData.element;
  const sliderInstance = sliderData.instance;

  //console.log(`[EVENTS] Attaching listeners for ${uniqueId}`);

  // Remove any existing listeners first
  if (slider._handleSliderChange) {
    sliderInstance.off('change', slider._handleSliderChange);
  }

  // Create the change handler
  const handleSliderChange = (values) => {
    const isUpdating = sliderState.updateFlags.get(uniqueId);
    if (isUpdating) {
      //console.log(`[CHANGE] Skipping update for ${uniqueId}, already updating`);
      return;
    }
    
    //console.log(`[CHANGE] Slider ${uniqueId} changed to:`, values);
    
    if (!Array.isArray(values)) {
      console.error(`[CHANGE] Values is not an array:`, values);
      return;
    }
    
    sliderState.updateFlags.set(uniqueId, true);
  
    const parseImperial = (val) => {
      const match = val.match(/(\d+)'(\d+)"/);
      if (!match) return 0;
      const [, ft, inch] = match;
      return toInches(ft, inch);
    };
    
    const minInches = parseImperial(values[0]);
    const maxInches = parseImperial(values[1]);
    
    //console.log(`[CHANGE] Converted to inches: ${minInches}-${maxInches}`);
  
    // Update URL parameter
    setURLParameter(urlParamName, formatRangeForURL(minInches, maxInches));
  
    // Find inputs within the current inches block
    const currentMinInput = inchesBlock.querySelector('input[data-type="min"]');
    const currentMaxInput = inchesBlock.querySelector('input[data-type="max"]');
  
    if (!currentMinInput || !currentMaxInput) {
      console.error(`[CHANGE] Could not find inputs to update`);
      sliderState.updateFlags.set(uniqueId, false);
      return;
    }
  
    //console.log(`[CHANGE] Updating inputs from ${currentMinInput.value}-${currentMaxInput.value} to ${minInches}-${maxInches}`);
    
    // Update the original inches inputs
    currentMinInput.value = minInches;
    currentMaxInput.value = maxInches;
  
    // Trigger change events
    [currentMinInput, currentMaxInput].forEach(input => {
      //console.log(`[CHANGE] Dispatching events for ${input.getAttribute('data-type')} input`);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Sync other sliders
    //console.log(`[CHANGE] Syncing other containers`);
    syncOtherContainerSliders(urlParamName, minInches, maxInches, uniqueId);
    
    setTimeout(() => {
      sliderState.updateFlags.set(uniqueId, false);
    }, 100);
  };

  // Store the handler reference
  slider._handleSliderChange = handleSliderChange;

  // Attach the handler
  sliderInstance.on('change', handleSliderChange);

  // Add debug listeners
  sliderInstance.on('update', (values) => {
    //console.log(`[UPDATE] Slider ${uniqueId} updating to:`, values);
  });

  sliderInstance.on('slide', (values) => {
    //console.log(`[SLIDE] Slider ${uniqueId} sliding to:`, values);
  });

  // Touch/mouse debugging
  slider.addEventListener('pointerdown', (e) => {
    //console.log(`[POINTER] Pointer down on slider ${uniqueId}`);
  }, { passive: true });

  // Monitor input changes
  const minInput = inchesBlock.querySelector('input[data-type="min"]');
  const maxInput = inchesBlock.querySelector('input[data-type="max"]');

  if (minInput && maxInput) {
    const inputHandler = (e) => {
      const isUpdating = sliderState.updateFlags.get(uniqueId);
      if (isUpdating) return;
      
      //console.log(`[INPUT] Input ${e.target.getAttribute('data-type')} changed for ${uniqueId}`);
      
      sliderState.updateFlags.set(uniqueId, true);
      
      const newMin = parseInt(minInput.value, 10) || 0;
      const newMax = parseInt(maxInput.value, 10) || 300;
      
      setURLParameter(urlParamName, formatRangeForURL(newMin, newMax));
      
      try {
        if (sliderInstance) {
          sliderInstance.set([newMin, newMax]);
        }
      } catch (error) {
        console.error(`[INPUT] Error setting slider:`, error);
      }

      syncOtherContainerSliders(urlParamName, newMin, newMax, uniqueId);
      
      setTimeout(() => {
        sliderState.updateFlags.set(uniqueId, false);
      }, 100);
    };

    minInput.addEventListener('change', inputHandler);
    maxInput.addEventListener('change', inputHandler);
  }
}

// Ensure event listeners are still attached
function ensureEventListeners(uniqueId, inchesBlock, urlParamName) {
  const sliderData = sliderState.instances.get(uniqueId);
  if (!sliderData || !sliderData.instance) return;

  // Test if the change handler is still working
  const testHandler = () => {
    //console.log(`[TEST] Change handler test for ${uniqueId} passed`);
  };
  
  sliderData.instance.on('change', testHandler);
  sliderData.instance.off('change', testHandler);
  
  // If the stored handler isn't attached, reattach it
  if (!sliderData.element._handleSliderChange) {
    //console.log(`[ENSURE] Reattaching event listeners for ${uniqueId}`);
    attachSliderEventListeners(uniqueId, inchesBlock, urlParamName);
  }
}

// Health monitoring to detect issues
function startHealthMonitoring(uniqueId) {
  // Clear any existing health check
  const existingCheck = sliderState.healthChecks.get(uniqueId);
  if (existingCheck) {
    clearInterval(existingCheck);
  }

  const healthCheck = setInterval(() => {
    const sliderData = sliderState.instances.get(uniqueId);
    if (!sliderData) {
      //console.log(`[HEALTH] Slider ${uniqueId} data not found, stopping health check`);
      clearInterval(healthCheck);
      return;
    }

    if (!document.body.contains(sliderData.element)) {
      console.error(`[HEALTH] Slider ${uniqueId} removed from DOM!`);
      cleanupSlider(uniqueId);
      clearInterval(healthCheck);
    } else if (!sliderData.element.noUiSlider) {
      console.error(`[HEALTH] Slider ${uniqueId} instance destroyed!`);
      cleanupSlider(uniqueId);
      clearInterval(healthCheck);
    }
  }, 2000);

  sliderState.healthChecks.set(uniqueId, healthCheck);
}

// Cleanup slider
function cleanupSlider(uniqueId) {
  //console.log(`[CLEANUP] Cleaning up slider ${uniqueId}`);
  
  const healthCheck = sliderState.healthChecks.get(uniqueId);
  if (healthCheck) {
    clearInterval(healthCheck);
    sliderState.healthChecks.delete(uniqueId);
  }
  
  sliderState.instances.delete(uniqueId);
  sliderState.updateFlags.delete(uniqueId);
}

// Sync sliders across containers
function syncOtherContainerSliders(urlParamName, minValue, maxValue, excludeId) {
  //console.log(`[SYNC] Syncing sliders for ${urlParamName}, excluding ${excludeId}`);
  
  sliderState.instances.forEach((sliderData, sliderId) => {
    if (sliderId !== excludeId && 
        sliderData.urlParamName === urlParamName && 
        sliderData.instance) {
      //console.log(`[SYNC] Updating slider ${sliderId} to ${minValue}-${maxValue}`);
      
      try {
        // Check if slider still exists and is functional
        if (document.body.contains(sliderData.element) && sliderData.element.noUiSlider) {
          sliderData.instance.set([minValue, maxValue]);
        } else {
          console.warn(`[SYNC] Slider ${sliderId} is not functional, skipping sync`);
        }
      } catch (e) {
        console.error(`[SYNC] Error updating slider ${sliderId}:`, e);
      }
    }
  });
}

// Convert refine-by section
function convertRefineBySectionToFeetInches() {
  const refineByList = document.querySelector('.boost-sd__refine-by-vertical-refine-by-list');
  if (!refineByList) return;

  const filterItems = refineByList.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-item');
  
  filterItems.forEach(item => {
    const optionSpan = item.querySelector('.boost-sd__refine-by-vertical-refine-by-option');
    const valueSpan = item.querySelector('.boost-sd__refine-by-vertical-refine-by-value');
    
    if (!optionSpan || !valueSpan) return;
    
    const optionText = optionSpan.textContent.trim();
    const valueText = valueSpan.textContent.trim();
    
    if ((optionText === 'Width:' || optionText === 'Length:') && valueText.match(/^\d+\s*-\s*\d+$/)) {
      const matches = valueText.match(/(\d+)\s*-\s*(\d+)/);
      if (!matches) return;
      
      const minInches = parseInt(matches[1], 10);
      const maxInches = parseInt(matches[2], 10);
      
      const minFeetInches = fromInches(minInches);
      const maxFeetInches = fromInches(maxInches);
      
      const minDisplay = `${minFeetInches.ft}'${minFeetInches.inch}"`;
      const maxDisplay = `${maxFeetInches.ft}'${maxFeetInches.inch}"`;
      
      valueSpan.textContent = `${minDisplay} - ${maxDisplay}`;
      
      // Add inch reference
      let inchReference = valueSpan.querySelector('.inch-reference');
      if (!inchReference) {
        inchReference = document.createElement('div');
        inchReference.className = 'inch-reference visually-hidden';
        inchReference.style.fontSize = '0.8em';
        inchReference.style.color = '#666';
        inchReference.style.marginTop = '2px';
        valueSpan.appendChild(inchReference);
      }
      inchReference.textContent = `(${minInches}" - ${maxInches}")`;
    }
  });
}

// Debounce helper
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Main injection function
const runInjection = () => {
  //console.log(`[RUN] Running injection cycle`);
  
  injectFeetInchesSlider({
    inchesSelector: 'div[data-filteroptionid="pf_rs1_width"]',
    sliderId: 'feet-inches-width-slider',
    labelText: 'Width (Feet & Inches)',
    urlParamName: 'pf_rs1_width'
  });

  injectFeetInchesSlider({
    inchesSelector: 'div[data-filteroptionid="pf_rs2_length"]',
    sliderId: 'feet-inches-length-slider',
    labelText: 'Length (Feet & Inches)',
    urlParamName: 'pf_rs2_length'
  });
  
  convertRefineBySectionToFeetInches();
};

// Debounced injection
const debouncedInject = debounce(runInjection, 300);

// Setup observers
const setupObservers = () => {
  // Observer specifically for mobile filter container re-renders
  const mobileFilterObserver = new MutationObserver((mutations) => {
    //console.log(`[MOBILE OBSERVER] Mobile filter container mutation detected`);
    
    // Check if the mutation includes the mobile filter tree
    const filterTreeChanged = mutations.some(mutation => {
      // Check if nodes were added/removed that contain the mobile filter tree
      const hasFilterTree = [...mutation.addedNodes, ...mutation.removedNodes].some(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.id === 'boost-sd_filter-tree-mobile' || 
               (node.querySelector && node.querySelector('#boost-sd_filter-tree-mobile'));
      });
      return hasFilterTree;
    });
    
    if (filterTreeChanged) {
      //console.log(`[MOBILE OBSERVER] Mobile filter tree changed, cleaning up and re-injecting`);
      
      // First, remove all existing custom sliders from the DOM
      const existingCustomSliders = document.querySelectorAll('[data-slider-id*="mobile"]');
      existingCustomSliders.forEach(slider => {
        //console.log(`[MOBILE OBSERVER] Removing custom slider element: ${slider.getAttribute('data-slider-id')}`);
        slider.remove();
      });
      
      // Clean up all mobile sliders from state
      sliderState.instances.forEach((data, id) => {
        if (id.includes('mobile')) {
          cleanupSlider(id);
        }
      });
      
      // Wait a bit for the DOM to stabilize, then re-inject
      setTimeout(() => {
        //console.log(`[MOBILE OBSERVER] Re-injecting mobile sliders after container change`);
        runInjection();
      }, 100);
    }
  });
  
  // Watch the specific mobile container
  const observeMobileContainer = () => {
    const mobileAppBlock = document.querySelector('div.boost-sd__filter-product-list.boost-sd__fpl-app-block');
    if (mobileAppBlock) {
      //console.log(`[MOBILE OBSERVER] Found mobile app block, starting observation`);
      mobileFilterObserver.observe(mobileAppBlock, {
        childList: true,
        subtree: true
      });
    } else {
      //console.log(`[MOBILE OBSERVER] Mobile app block not found yet, will retry`);
      // Retry in a bit if the container doesn't exist yet
      setTimeout(observeMobileContainer, 1000);
    }
  };
  
  observeMobileContainer();

  // Main observer for other dynamic content (desktop, refine-by, etc.)
  const rangeObserver = new MutationObserver((mutations) => {
    //console.log(`[OBSERVER] General mutation detected`);
    
    // Only process if it's not a mobile filter change (handled by specific observer)
    const isMobileFilterChange = mutations.some(mutation => {
      return mutation.target.closest('div.boost-sd__filter-product-list.boost-sd__fpl-app-block');
    });
    
    if (!isMobileFilterChange) {
      debouncedInject();
    }
  });

  rangeObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Refine-by observer
  const refineByObserver = new MutationObserver(() => {
    convertRefineBySectionToFeetInches();
  });

  const startRefineByObserver = () => {
    const refineBySection = document.querySelector('.boost-sd__refine-by-vertical-refine-by-list');
    if (refineBySection) {
      refineByObserver.observe(refineBySection, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };

  startRefineByObserver();
};

// Initialize
//console.log(`[INIT] Starting feet/inches slider script v3 - Mobile re-render aware`);
setupObservers();
setupMobileEventDelegation();
runInjection();

// Also set up a periodic check for mobile container health
setInterval(() => {
  const mobileContainer = document.querySelector('#boost-sd_filter-tree-mobile');
  if (mobileContainer) {
    // Check if our mobile sliders are still functional
    let mobileSlidersBroken = false;
    sliderState.instances.forEach((data, id) => {
      if (id.includes('mobile') && (!document.body.contains(data.element) || !data.element.noUiSlider)) {
        //console.log(`[PERIODIC CHECK] Mobile slider ${id} is broken`);
        mobileSlidersBroken = true;
      }
    });
    
    if (mobileSlidersBroken) {
      //console.log(`[PERIODIC CHECK] Detected broken mobile sliders, cleaning up and re-injecting`);
      
      // First remove all custom mobile sliders from DOM
      const existingCustomSliders = document.querySelectorAll('[data-slider-id*="mobile"]');
      existingCustomSliders.forEach(slider => {
        //console.log(`[PERIODIC CHECK] Removing stale custom slider: ${slider.getAttribute('data-slider-id')}`);
        slider.remove();
      });
      
      // Clean up broken mobile sliders from state
      sliderState.instances.forEach((data, id) => {
        if (id.includes('mobile')) {
          cleanupSlider(id);
        }
      });
      
      // Re-inject
      runInjection();
    }
  }
}, 3000);